// Mock data for Onvyn website

export const heroData = {
  tagline: "We help health-first brands communicate science clearly.",
  subtitle: "Strategy, design, and digital growth for healthcare and wellness brands.",
  ctaText: "Schedule a Free Consultation",
  ctaLink: "/contact"
};

export const servicesOverview = [
  {
    id: 1,
    icon: "Target",
    title: "Strategy & Positioning",
    description: "Insight-led strategy that helps healthcare brands define their message, audience, and growth direction.",
    link: "/services#strategy"
  },
  {
    id: 2,
    icon: "Palette",
    title: "Content & Creative",
    description: "Thoughtful and creative designs, content, packaging, and campaigns that simplify complex healthcare ideas and build trust.",
    link: "/services#creative"
  },
  {
    id: 3,
    icon: "TrendingUp",
    title: "Digital Growth",
    description: "Social media, SEO, ads, marketplaces and platforms designed to drive steady, responsible growth for healthcare brands.",
    link: "/services#digital"
  }
];

export const servicesDetailed = [
  {
    id: 1,
    slug: "strategy",
    title: "Brand Strategy & Identity",
    description: "We help healthcare brands define who they are, what they stand for, and how they communicate. From naming to visual identity, we build brands that feel credible, consistent, and trustworthy across every touchpoint.",
    icon: "Target"
  },
  {
    id: 2,
    slug: "performance",
    title: "Performance Marketing",
    description: "Targeted ad campaigns across Meta, Google, and relevant platforms, designed to drive qualified leads, patient enquiries, and measurable growth without compromising compliance.",
    icon: "BarChart3"
  },
  {
    id: 3,
    slug: "website",
    title: "Website Design & Development",
    description: "High-performance, SEO-ready websites built for healthcare brands. Designed to educate, build trust, and convert visitors into patients or customers.",
    icon: "Globe"
  },
  {
    id: 4,
    slug: "content",
    title: "Content & Video Creation",
    description: "Clear, thoughtful content and visual storytelling that simplifies complex healthcare messages and connects meaningfully with your audience.",
    icon: "Video"
  },
  {
    id: 5,
    slug: "marketplace",
    title: "Amazon & Marketplaces",
    description: "We help healthcare and wellness brands build, optimise, and scale their presence on Amazon and leading marketplaces. From product listings and A+ content to performance advertising and ongoing optimisation.",
    icon: "ShoppingCart"
  },
  {
    id: 6,
    slug: "launch",
    title: "Product Launch & Market Strategy",
    description: "We design go-to-market strategies for new products and services. From positioning and messaging to channel planning and launch execution.",
    icon: "Rocket"
  },
  {
    id: 7,
    slug: "social",
    title: "Social Media Marketing",
    description: "Strategic, compliant social media content for Instagram, Facebook, and LinkedIn that builds visibility, credibility, and long-term engagement.",
    icon: "Share2"
  },
  {
    id: 8,
    slug: "medical",
    title: "Medical Writing & Communication",
    description: "Scientifically accurate, ethically compliant medical content that educates patients, supports brands, and strengthens healthcare communication across platforms.",
    icon: "FileText"
  }
];

export const workProcess = [
  {
    id: 1,
    phase: "Strategy",
    steps: [
      {
        title: "Diagnose",
        description: "We start by understanding your brand's reality. Through audits, research, and stakeholder inputs, we identify gaps, opportunities, and the real challenges that need solving."
      },
      {
        title: "Position",
        description: "With clarity on where you stand, we define where you should go. We shape brand positioning and messaging that reflects your strengths and connects with the right audience."
      },
      {
        title: "Plan",
        description: "We turn strategy into action with a focused roadmap covering content, platforms, campaigns, and metrics. Every step is practical, realistic, and aligned with your business goals."
      }
    ]
  },
  {
    id: 2,
    phase: "Execution",
    steps: [
      {
        title: "Create",
        description: "We bring ideas to life through thoughtful branding, clear content, and purposeful design. Every asset we create balances creativity with accuracy, compliance, and clarity."
      },
      {
        title: "Launch",
        description: "We take your message to the right platforms, from social media and search to performance campaigns. Using the right mix of organic and paid, we ensure your brand reaches the right audience."
      },
      {
        title: "Optimise",
        description: "We continuously track, learn, and refine. By analysing performance and user behaviour, we improve results, strengthen ROI, and support sustainable growth over time."
      }
    ]
  }
];

export const caseStudyData = {
  title: "Thoughtful Strategy. Responsible Growth.",
  subtitle: "In just 6 months, we helped an Ayurveda pharma brand achieve",
  metrics: [
    {
      id: 1,
      value: "₹10L+",
      label: "in E-Commerce Sales",
      description: "Achieved through integrated digital strategy, social media marketing, and an optimised marketplace presence across Amazon and Flipkart."
    },
    {
      id: 2,
      value: "₹1.5L+",
      label: "Ad Spend Managed",
      description: "Performance-led campaigns across Meta and marketplaces, optimised for efficiency, ROAS, and sustainable conversions."
    },
    {
      id: 3,
      value: "3x",
      label: "Increase in Website Traffic",
      description: "Improved visibility and engagement through SEO, targeted campaigns, and consistent content optimisation."
    },
    {
      id: 4,
      value: "70%",
      label: "Growth in New Customers",
      description: "Stronger customer acquisition and retention supported by data-led insights, repeat purchase strategies, and brand-led communication."
    }
  ]
};

export const testimonialsData = [
  {
    id: 1,
    quote: "Use this space to share a testimonial quote about the business, its products or its services. Insert a quote from a real customer or client here to build trust and win over site visitors.",
    author: "Maria Goncavales",
    position: "CFO",
    company: "Laderate"
  },
  {
    id: 2,
    quote: "Use this space to share a testimonial quote about the business, its products or its services. Insert a quote from a real customer or client here to build trust and win over site visitors.",
    author: "Michael Soveign",
    position: "CEO",
    company: "Seven Energy"
  },
  {
    id: 3,
    quote: "Use this space to share a testimonial quote about the business, its products or its services. Insert a quote from a real customer or client here to build trust and win over site visitors.",
    author: "Jeffrey Cohen",
    position: "CEO",
    company: "Nato Productions"
  }
];

export const aboutData = {
  title: "Our Story",
  subtitle: "Led by creative strategy, informed by medical insight, built for healthcare brands.",
  content: [
    "Onvyn was built on a simple belief: healthcare communication deserves clarity, responsibility, and creative integrity.",
    "As a healthcare marketing consulting firm we work with clinics, healthcare brands, and wellness businesses that want to grow without compromising trust. Our approach blends strategy, science-backed thinking, and thoughtful design to help brands communicate complex ideas clearly and ethically.",
    "We don't chase trends or shortcuts. Instead, we focus on building long-term value through structured thinking, compliant communication, and work that genuinely serves both brands and people."
  ]
};

export const teamData = [
  {
    id: 1,
    name: "Team Member 1",
    position: "Strategy Director",
    bio: "Healthcare marketing strategist with 10+ years of experience."
  },
  {
    id: 2,
    name: "Team Member 2",
    position: "Creative Director",
    bio: "Award-winning designer specializing in healthcare branding."
  },
  {
    id: 3,
    name: "Team Member 3",
    position: "Digital Growth Lead",
    bio: "Performance marketing expert focused on healthcare sector."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Essential Healthcare Marketing Strategies for 2025",
    slug: "healthcare-marketing-strategies-2025",
    excerpt: "Discover the latest trends and strategies that are shaping healthcare marketing in 2025. From AI-powered personalization to patient-centric content.",
    category: "Strategy",
    author: "Onvyn Team",
    date: "2024-12-10",
    readTime: "5 min read",
    image: "https://images.pexels.com/photos/7195308/pexels-photo-7195308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Full blog post content here..."
  },
  {
    id: 2,
    title: "Building Trust Through Compliant Healthcare Content",
    slug: "building-trust-compliant-content",
    excerpt: "Learn how to create compelling healthcare content that maintains regulatory compliance while building authentic connections with your audience.",
    category: "Content",
    author: "Onvyn Team",
    date: "2024-12-05",
    readTime: "7 min read",
    image: "https://images.pexels.com/photos/5327580/pexels-photo-5327580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Full blog post content here..."
  },
  {
    id: 3,
    title: "Digital Growth Tactics for Healthcare Brands",
    slug: "digital-growth-healthcare-brands",
    excerpt: "Proven digital growth strategies that help healthcare brands scale responsibly while maintaining trust and compliance.",
    category: "Digital Marketing",
    author: "Onvyn Team",
    date: "2024-11-28",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1762279389020-eeeb69c25813?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwZ3Jvd3RoJTIwdmlzdWFsaXphdGlvbnxlbnwwfHx8fDE3NzE0Mzg5NzB8MA&ixlib=rb-4.1.0&q=85",
    content: "Full blog post content here..."
  },
  {
    id: 4,
    title: "The Power of Medical Writing in Brand Communication",
    slug: "medical-writing-brand-communication",
    excerpt: "Why accurate medical writing is crucial for healthcare brands and how it impacts patient trust and brand credibility.",
    category: "Medical Writing",
    author: "Onvyn Team",
    date: "2024-11-20",
    readTime: "8 min read",
    image: "https://images.pexels.com/photos/5998477/pexels-photo-5998477.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Full blog post content here..."
  },
  {
    id: 5,
    title: "Amazon Marketplace Success for Healthcare Products",
    slug: "amazon-marketplace-healthcare-success",
    excerpt: "A comprehensive guide to launching and scaling healthcare products on Amazon while maintaining compliance and building brand equity.",
    category: "E-commerce",
    author: "Onvyn Team",
    date: "2024-11-15",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1768055104929-cf2317674a80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwZ3Jvd3RoJTIwdmlzdWFsaXphdGlvbnxlbnwwfHx8fDE3NzE0Mzg5NzB8MA&ixlib=rb-4.1.0&q=85",
    content: "Full blog post content here..."
  },
  {
    id: 6,
    title: "Social Media Compliance for Healthcare Brands",
    slug: "social-media-compliance-healthcare",
    excerpt: "Navigate the complexities of social media marketing in healthcare while staying compliant with regulations and building meaningful engagement.",
    category: "Social Media",
    author: "Onvyn Team",
    date: "2024-11-10",
    readTime: "6 min read",
    image: "https://images.pexels.com/photos/9489091/pexels-photo-9489091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Full blog post content here..."
  }
];

export const clientLogos = [
  { id: 1, name: "Client 1" },
  { id: 2, name: "Client 2" },
  { id: 3, name: "Client 3" },
  { id: 4, name: "Client 4" },
  { id: 5, name: "Client 5" },
  { id: 6, name: "Client 6" }
];

export const footerData = {
  companyName: "Onvyn",
  tagline: "Healthcare Marketing with Clarity & Integrity",
  description: "We help health-first brands communicate science clearly through strategy, design, and digital growth.",
  links: {
    company: [
      { label: "About Us", href: "/about" },
      { label: "Our Story", href: "/about#story" },
      { label: "Insights", href: "/blog" }
    ],
    services: [
      { label: "Strategy & Positioning", href: "/services#strategy" },
      { label: "Performance Marketing", href: "/services#performance" },
      { label: "Website Design", href: "/services#website" },
      { label: "Content Creation", href: "/services#content" }
    ],
    resources: [
      { label: "Blog", href: "/blog" },
      { label: "Case Studies", href: "/#case-study" },
      { label: "Contact", href: "/contact" }
    ]
  },
  social: [
    { platform: "LinkedIn", url: "https://linkedin.com", icon: "Linkedin" },
    { platform: "Twitter", url: "https://twitter.com", icon: "Twitter" },
    { platform: "Instagram", url: "https://instagram.com", icon: "Instagram" },
    { platform: "Facebook", url: "https://facebook.com", icon: "Facebook" }
  ],
  contact: {
    email: "business@onvyn.com",
    phone: "+91 86693 34305",
    address: "Office No. 702, Icon Tower, Baner Rd, Baner, Pune, Maharashtra, India – 411045"
  }
};
